import React from 'react'
import "./Products.css"
import Products2 from './Products2';
import Products3 from './Products3';
import Products4 from './Products4';
import Products6 from './Products6';
// import Products5 from './Products5';

const Products = () => {
  return (
    <>
    {/* <div className='body'> */}
      {/* <div className="container12">
        <div className="textblock12">
            <h1 className='title12'>Our Products</h1>
            <h4 className="sub-title12">Make an investment in yourself</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro in corporis minus consequatur aliquid nesciunt, est odit repudiandae et illo?</p>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro in corporis minus consequatur aliquid nesciunt, est odit repudiandae et illo?</p>

        </div>
        <img src="/images/50.jpg" alt="" />
      </div> */}
    {/* </div> */}
    <Products6 />
    {/* <Products4 /> */}
    <Products2 />
    <Products3 />
    {/* <Products5 /> */}

    </>
  )
}

export default Products
